import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';

import RelatorioPDF from './Relatorio/tpProdutoDaf001';
import {
  headersIncoporacao,
  headersOutrosSistemas,
  valoresExibidosIncorporacao,
  valoresExibidosOutrosSistemas,
} from './auxiliarProdutosDaf';
import SubAbasProdutosDaf from './subabasProdutosDaf';
import { TypeDenominacaoGenerica } from './types';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import CheckBoxList from '../../../../components/CheckBoxList';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import CustomSpan from '../../../../components/CustomSpan';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import Modal from '../../../../components/Modal';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { LogData } from '../../../../modules/types/types';
import { useAcondicionamento } from '../../../../services/enum/useAcondicionamento';
import { useClassificacaoAware } from '../../../../services/enum/useClassificacaoAware';
import { useComponentesPaf } from '../../../../services/enum/useComponentesPaf';
import { useDocumentoOrientador } from '../../../../services/enum/useDocumentoOrientador';
import { useFormaFarmaceutica } from '../../../../services/enum/useFormaFarmaceutica';
import { useGrupoFinanciamento } from '../../../../services/enum/useGrupoFinanciamento';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { useOutroSistema } from '../../../../services/enum/useOutroSistema';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { useStatusIncorporacao } from '../../../../services/enum/useStatusIncorporacao';
import { useStatusPactuacao } from '../../../../services/enum/useStatusPactuacao';
import { useStatusRename } from '../../../../services/enum/useStatusRename';
import { useTipoProduto } from '../../../../services/enum/useTipoProduto';
import { useUmidadeProduto } from '../../../../services/enum/useUmidadeProduto';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { getAllDenominacoesGenericas } from '../../../../services/produtosDAF/denominacoesGenericasService';
import {
  getAllKitDeProdutoPorProdutoId,
  getKitDeProdutoPorProdutoId,
} from '../../../../services/produtosDAF/kitProdutoService';
import {
  getProdutoDAF,
  getProdutoDAFIncorporacao,
  getProdutoDAFOutroSistema,
} from '../../../../services/produtosDAF/produtosDafService';
import {
  getAllTags,
  saveTags,
} from '../../../../services/produtosDAF/tagsProdutosDafService';
import { FormaFarmaceuticaMatch } from '../../../../utils/formaFarmaceuticaMatch';
import {
  checkValueStatus,
  clearAllCache,
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
  formatDtTm,
} from '../../../../utils/functions';
import { useCalculaPercentualDisponivel } from '../../../../utils/functions';
import {
  swal,
  swalAttention,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../utils/swal';
import {
  headersKitsProdutos,
  valoresExibidosOffCanvasKitProdutos,
} from '../Kits/auxiliarKitProdutos';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;

const ProdutosDadosGerais: React.FC = () => {
  const CACHE_KEY = 'cachedProdutos';
  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find(
      (modulo) => modulo.label === 'Produtos Farmacêuticos',
    )?.value || '0',
  );

  // Verificar permissões para ações
  //const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  //const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);

  const canDelete = isActionAllowed(MODULO, 'delete', papelUsuarioOptions);
  const canSave = isActionAllowed(MODULO, 'update', papelUsuarioOptions);
  //PERMISSOES
  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);
  const listenChange = useRef(false);
  const checkListenChange = (change: boolean) => {
    if (!change) {
      swalAttention(
        'Não houve mudanças no registro.<br> Registro não foi salvo.',
      ); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  //Dados do componente
  let logs = {};
  let subAbas = [];
  const tipoProduto = useTipoProduto();
  const formaFarmaceutica = useFormaFarmaceutica();
  const acondicionamento = useAcondicionamento();
  const umidade = useUmidadeProduto();
  const classificacaoAware = useClassificacaoAware();
  const statusIncorporacao = useStatusIncorporacao();
  const outroSistema = useOutroSistema();
  const documentoOrientador = useDocumentoOrientador();
  const grupoFinanciamento = useGrupoFinanciamento();
  const componenteAf = useComponentesPaf();
  const statusPactuacao = useStatusPactuacao();
  const statusRename = useStatusRename();

  const [denominacaoGenericaData, setdenominacaoGenericaData] = useState<
    TypeDenominacaoGenerica[]
  >([]);

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formProduto, setFormProduto] = useState({
    id: 0,
    usuarioId: userID,
    denominacaoGenericaId: 0,
    atcId: 1,
    aware: 0,
    formaFarmaceutica: 0,
    formaFarmaceuticaSimp: 0,
    formaFarmaceuticaLabel: '',
    umidade: 0,
    acondicionamento: 0,
    statusRename: 0,
    produtoFarmaceutico: '',
    concentracao: '',
    oncologico: '',
    biologico: '',
    statusDistribuicao: '',
    compBasico: '',
    compEspecializado: '',
    compEstrategico: '',
    especializadoGrupo: 0,
    usoHospitalar: '',
    farmaciaPopular: '',
    dataRenamePublicacao: '',
    dataRenameExclusao: '',
    dataRenameAmpliacao: '',
    codigoAtc: '',
    sigtapPossui: '',
    sigtapCodigo: '',
    sigtapNome: '',
    sismatPossui: '',
    sismatCodigo: '',
    sismatNome: '',
    catmatPossui: '',
    catmatCodigo: '',
    catmatNome: '',
    obmPossui: '',
    obmCodigo: '',
    obmNome: '',
    observacoes: '',
    tags: '',
    tagsArray: [] as { id: number; tag: string }[],
  });

  const [formIncorporacao, setFormIncorporacao] = useState({
    id: '',
    usuarioId: userID,
    produtoDAFId: formProduto.id,
    statusIncorporacao: 0,
    statusPactuacao: 0,
    componentePactuado: 0,
    componenteGrupoFinanciamento: 0,
    documentoTecnicoOrientador: 0,
    dataIncorporacao: '',
    portariaIncorporacao: '',
    linkPortariaIncorporacao: '',
    documentoTecnicoOrientadorTitulo: '',
    dataDocumento: '',
    documentoTecnicoOrientadorLink: '',
    dataDesincorporacao: '',
    portariaDesincorporacao: '',
    linkPortariaDesincorporacao: '',
    dataPactuacao: '',
    ataPactuacao: '',
    ataPactuacaoLink: '',
    observacoes: '',
  });

  const [formOutroSistema, setFormOutroSistema] = useState({
    id: '',
    usuarioId: userID,
    produtoDAFId: formProduto.id,
    outroSistema: 0,
    codigoProduto: '',
    nomeProduto: '',
    observacoes: '',
  });

  const denominacoesGenericasOptions = [
    { value: 0, label: 'Não informado' },
    ...denominacaoGenericaData.map((item) => ({
      value: item.id,
      label: item.denominacaoGenerica,
    })),
  ];

  const statusBin = [
    { value: 1, label: 'Sim' },
    { value: 2, label: 'Não' },
  ];

  // Novo estado para armazenar as tags dos produtos (como objetos)
  const [tagsProdutos, setTagsProdutos] = useState<
    { id: number; tag: string }[]
  >([]);

  // useEffect para buscar as tags ao carregar o componente
  useEffect(() => {
    const fetchTags = async () => {
      try {
        const tags = await getAllTags();

        // Move a tag "Nenhuma tag" para o início do array
        const tagsReordenadas = tags.sort((a, b) => {
          if (a.id === 9999) return -1; // Move "Nenhuma tag" para o início
          if (b.id === 9999) return 1; // Move outras para depois
          return 0; // Mantém a ordem original
        });

        setTagsProdutos(tagsReordenadas);
      } catch (error) {
        console.error('Erro ao obter tags:', error);
      }
    };

    fetchTags();
  }, []);

  //Kits de Produtos
  const [dataKit, setDataKit] = useState<any[]>([]);

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const produtoData = await getProdutoDAF(id);

      const dataRenamePublicacao = produtoData.dataRenamePublicacao
        ? new Date(produtoData.dataRenamePublicacao).toISOString().split('T')[0]
        : '';

      const dataRenameAmpliacao = produtoData.dataRenameAmpliacao
        ? new Date(produtoData.dataRenameAmpliacao).toISOString().split('T')[0]
        : '';

      const dataRenameExclusao = produtoData.dataRenameExclusao
        ? new Date(produtoData.dataRenameExclusao).toISOString().split('T')[0]
        : '';

      setLogData(produtoData);
      setFormProduto({
        id: produtoData.id,
        usuarioId: userID,
        denominacaoGenericaId: produtoData.denominacaoGenerica.id,
        atcId: 0,
        aware: produtoData.aware,
        formaFarmaceutica: produtoData.formaFarmaceutica,
        formaFarmaceuticaLabel: '',
        formaFarmaceuticaSimp: produtoData.formaFarmaceuticaSimp,
        umidade: produtoData.umidade,
        acondicionamento: produtoData.acondicionamento,
        produtoFarmaceutico: produtoData.produtoFarmaceutico,
        concentracao: produtoData.concentracao,
        oncologico: produtoData.oncologico,
        biologico: produtoData.biologico,
        statusDistribuicao: produtoData.statusDistribuicao,
        statusRename: produtoData.statusRename,
        dataRenamePublicacao: dataRenamePublicacao,
        dataRenameExclusao: dataRenameExclusao,
        dataRenameAmpliacao: dataRenameAmpliacao,
        codigoAtc: produtoData.codigoAtc,
        compBasico: produtoData.compBasico,
        compEspecializado: produtoData.compEspecializado,
        compEstrategico: produtoData.compEstrategico,
        especializadoGrupo: produtoData.especializadoGrupo,
        usoHospitalar: produtoData.usoHospitalar,
        farmaciaPopular: produtoData.farmaciaPopular,
        sigtapPossui: produtoData.sigtapPossui,
        sigtapCodigo: produtoData.sigtapCodigo,
        sigtapNome: produtoData.sigtapNome,
        sismatPossui: produtoData.sismatPossui,
        sismatCodigo: produtoData.sismatCodigo,
        sismatNome: produtoData.sismatNome,
        catmatPossui: produtoData.catmatPossui,
        catmatCodigo: produtoData.catmatCodigo,
        catmatNome: produtoData.catmatNome,
        obmPossui: produtoData.obmPossui,
        obmCodigo: produtoData.obmCodigo,
        obmNome: produtoData.obmNome,
        observacoes: produtoData.observacoes,
        tags: produtoData.tags,
        tagsArray: produtoData.tagsArray,
      });

      const kitProdutos = await getAllKitDeProdutoPorProdutoId(id);
      setDataKit(kitProdutos);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //Kits de Produtos
  const tableDataKit = dataKit.map((item) => ({
    id: item.id,
    // statusKit: item.statusKit ? statusKit[item.statusKit].label : null,
    statusKit:
      item.statusKit === 1 ? (
        <CustomSpan texto="Ativo" />
      ) : (
        <CustomSpan texto="Inativo" />
      ),
    componenteAF:
      componenteAf.find(
        (option) => option.value === item.componenteAF.toString(),
      )?.label || 'Não informado',
    nomeKit: item.nomeKit,
    produtos:
      item.produtos.length > 0 ? (
        <ul style={{ marginBottom: '2px', paddingLeft: '20px' }}>
          {item.produtos
            .sort((a: any, b: any) =>
              a.produtoFarmaceutico.localeCompare(b.produtoFarmaceutico),
            ) // Ordena os produtos
            .map((produto: any, index: number) => (
              <li key={index} style={{ marginBottom: '5px' }}>
                <b>{produto.produtoFarmaceutico}</b>
                <br />
                <span
                  style={{
                    marginLeft: '0px',
                  }}
                >
                  Quantidade por Kit: {produto.quantidade.toLocaleString()}{' '}
                  unidades
                </span>
              </li>
            ))}
        </ul>
      ) : (
        <span style={{ fontStyle: 'italic', color: '#888' }}>
          Não informado
        </span>
      ),
  }));

  const offCanvasKit = dataKit.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    // statusKit: item.statusKit ? statusKit[item.statusKit].label : null,
    statusKit:
      item.statusKit === 1 ? (
        <CustomSpan texto="Ativo" />
      ) : (
        <CustomSpan texto="Inativo" />
      ),
    componenteAF: item.componenteAF
      ? componenteAf[item.componenteAF].label
      : null,
    nomeKit: item.nomeKit,
    descricao: item.descricao,
    produtos: (
      <ul style={{ marginBottom: '2px' }}>
        {item.produtos
          .sort((a: any, b: any) =>
            a.produtoFarmaceutico.localeCompare(b.produtoFarmaceutico),
          ) // Ordena os produtos
          .map((produto: any, index: number) => (
            <li key={index} style={{ marginBottom: '5px' }}>
              <b>{produto.produtoFarmaceutico}</b>
              <br />
              <span
                style={{
                  marginLeft: '0px',
                }}
              >
                Quantidade por Kit: {produto.quantidade.toLocaleString()}{' '}
                unidades
              </span>
            </li>
          ))}
      </ul>
    ),

    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  const [incorporacoesData, setIncorporacoesData] = useState<any[]>([]);
  const fetchDataIncorporacao = async (id: string) => {
    try {
      const incorporacaoData = await getProdutoDAFIncorporacao(id);

      if (incorporacaoData.length > 0) {
        setIncorporacoesData(incorporacaoData);
        setUpdatingIncorporacao(true);
      }
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  const tableDataIncorporacoes = incorporacoesData.map((item) => {
    // Definindo cores de fundo e texto com base no status do ticket
    let statusBackgroundColor = '';
    let statusTextColor = '';
    let statusPactuacaoBg = '';
    let statusPactuacaoText = '';

    const verde = '#09af09a7';
    const vermelho = '#e91212c3';
    const amarelo = '#faffb4dd';

    const statusLabel = statusIncorporacao[item.statusIncorporacao].label;
    const statusPactuacaoLabel = statusPactuacao[item.statusPactuacao].label;

    if (statusLabel === 'Incorporado') {
      statusBackgroundColor = verde;
      statusTextColor = 'white';
    } else if (statusLabel === 'Em incorporação') {
      statusBackgroundColor = amarelo;
      statusTextColor = 'black';
    } else if (statusLabel === 'Desincorporado') {
      statusBackgroundColor = vermelho;
      statusTextColor = 'white';
    }

    if (statusPactuacaoLabel === 'Não informado') {
      statusPactuacaoBg = 'white';
      statusPactuacaoText = 'black';
    } else if (statusPactuacaoLabel === 'Não Pactuado') {
      statusPactuacaoBg = vermelho;
      statusPactuacaoText = 'white';
    } else if (statusPactuacaoLabel === 'Pactuado') {
      statusPactuacaoBg = verde;
      statusPactuacaoText = 'white';
    }
    return {
      id: item.id,
      statusIncorporacao: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '-10px',
          }}
        >
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              borderRadius: '10px',
              padding: '10px',
              color: statusTextColor,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusLabel}
          </span>
        </div>
      ),
      statusPactuacao: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '-10px',
          }}
        >
          <span
            style={{
              backgroundColor: statusPactuacaoBg,
              borderRadius: '10px',
              padding: '10px',
              color: statusPactuacaoText,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusPactuacaoLabel}
          </span>
        </div>
      ),
      dataIncorporacao: formatDateSimp(item.dataIncorporacao),
      portariaIncorporacao: item.portariaIncorporacao
        ? item.portariaIncorporacao
        : '-',
      dataPactuacao: formatDateSimp(item.dataPactuacao),
      ataPactuacao: item.ataPactuacao ? item.ataPactuacao : '-',
      componentePactuado: item.componentePactuado
        ? componenteAf[item.componentePactuado].label
        : '-',
    };
  });

  const offCanvasDataIncorporacoes = incorporacoesData.map((item) => {
    // Definindo cores de fundo e texto com base no status do ticket
    let statusBackgroundColor = '';
    let statusTextColor = '';
    let statusPactuacaoBg = '';
    let statusPactuacaoText = '';
    const verde = '#09af09a7';
    const vermelho = '#e91212c3';
    const amarelo = '#faffb4dd';

    const statusLabel = statusIncorporacao[item.statusIncorporacao].label;
    if (statusLabel === 'Em incorporação') {
      statusBackgroundColor = amarelo;
      statusTextColor = 'black';
    } else if (statusLabel === 'Incorporado') {
      statusBackgroundColor = verde;
      statusTextColor = 'white';
    } else if (statusLabel === 'Desincorporado') {
      statusBackgroundColor = vermelho;
      statusTextColor = 'white';
    }

    const statusPactuacaoLabel = statusPactuacao[item.statusPactuacao].label;
    if (statusPactuacaoLabel === 'Não informado') {
      statusPactuacaoBg = 'white';
      statusPactuacaoText = 'black';
    } else if (statusPactuacaoLabel === 'Não Pactuado') {
      statusPactuacaoBg = vermelho;
      statusPactuacaoText = 'white';
    } else if (statusPactuacaoLabel === 'Pactuado') {
      statusPactuacaoBg = verde;
      statusPactuacaoText = 'white';
    }
    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      statusIncorporacao: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '-10px',
          }}
        >
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              borderRadius: '10px',
              padding: '10px',
              color: statusTextColor,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusLabel}
          </span>
        </div>
      ),
      statusPactuacao: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '-10px',
          }}
        >
          <span
            style={{
              backgroundColor: statusPactuacaoBg,
              borderRadius: '10px',
              padding: '10px',
              color: statusPactuacaoText,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusPactuacaoLabel}
          </span>
        </div>
      ),
      separadorIncorporacao: '',
      dataIncorporacao: formatDateSimp(item.dataIncorporacao),
      portariaIncorporacao: item.portariaIncorporacao
        ? item.portariaIncorporacao
        : item.portariaIncorporacao,

      linkPortariaIncorporacao: item.linkPortariaIncorporacao,
      separadorDocumento: '',
      documentoTecnicoOrientador:
        documentoOrientador[item.documentoTecnicoOrientador].label,
      dataDocumento: item.dataDocumento
        ? formatDateSimp(item.dataDocumento)
        : '-',
      documentoTecnicoOrientadorTitulo: item.documentoTecnicoOrientadorTitulo,
      documentoTecnicoOrientadorLink: item.documentoTecnicoOrientadorLink ? (
        <a
          href={
            item.documentoTecnicoOrientadorLink.startsWith('http')
              ? item.documentoTecnicoOrientadorLink
              : `https://${item.documentoTecnicoOrientadorLink}`
          }
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          {item.documentoTecnicoOrientadorLink}
        </a>
      ) : (
        '-'
      ),

      separadorPactuacao: '',
      dataPactuacao: item.dataPactuacao
        ? formatDateSimp(item.dataPactuacao)
        : '-',
      ataPactuacao: item.ataPactuacao,
      ataPactuacaoLink: item.ataPactuacaoLink ? (
        <a
          href={
            item.ataPactuacaoLink.startsWith('http')
              ? item.ataPactuacaoLink
              : `https://${item.ataPactuacaoLink}`
          }
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          {item.ataPactuacaoLink}
        </a>
      ) : (
        '-'
      ),
      separadorDesincorporacao: '',
      dataDesincorporacao: item.dataDesincorporacao
        ? item.dataDesincorporacao
        : '-',
      portariaDesincorporacao: item.portariaDesincorporacao
        ? item.portariaDesincorporacao
        : '-',
      linkPortariaDesincorporacao: item.linkPortariaDesincorporacao ? (
        <a
          href={
            item.linkPortariaDesincorporacao.startsWith('http')
              ? item.linkPortariaDesincorporacao
              : `https://${item.linkPortariaDesincorporacao}`
          }
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          {item.linkPortariaDesincorporacao}
        </a>
      ) : (
        '-'
      ),

      separadorObservacoes: '',
      observacoes: item.observacoes ? item.observacoes : '-',
    };
  });

  const [showModalIncorporacao, setShowModalIncorporacao] =
    useState<boolean>(false);
  const [updatingIncorporacao, setUpdatingIncorporacao] =
    useState<boolean>(false);
  const [logIncorporacaData, setLogIncorporacaoData] = useState<LogData>();

  const handleShowModalIncorporacao = () => {
    setShowModalIncorporacao((prev) => !prev);
    handleClearFormIncorporacao();
  };

  const [outroSistemaData, setOutroSistemaData] = useState<any[]>([]);
  const fetchDataOutroSistema = async (id: string) => {
    try {
      const outroSistemaData = await getProdutoDAFOutroSistema(id);

      if (outroSistemaData.length > 0) {
        setOutroSistemaData(outroSistemaData);
        setUpdatingOutroSistema(true);
      }
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  const tableDataOutroSistema = outroSistemaData.map((item) => {
    return {
      id: item.id,
      outroSistema: outroSistema[item.outroSistema].label,
      codigoProduto: item.codigoProduto,
      nomeProduto: item.nomeProduto,
    };
  });

  const offCanvasDataOutroSistema = outroSistemaData.map((item) => {
    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      outroSistema: outroSistema[item.outroSistema].label,
      codigoProduto: item.codigoProduto,
      nomeProduto: item.nomeProduto,
      separadorObservacoes: '',
      observacoes: item.observacoes ? item.observacoes : '-',
    };
  });

  const [showModalOutroSistema, setShowModalOutroSistema] =
    useState<boolean>(false);
  const [updatingOutroSistema, setUpdatingOutroSistema] =
    useState<boolean>(false);
  const [, setLogOutroSistemaData] = useState<LogData>();

  const handleShowModalOutroSistema = () => {
    setShowModalOutroSistema((prev) => !prev);
    handleClearFormOutroSistema();
  };

  const handleClearFormIncorporacao = () => {
    setFormIncorporacao({
      id: '',
      usuarioId: userID,
      produtoDAFId: formProduto.id,
      statusIncorporacao: 0,
      documentoTecnicoOrientador: 0,
      componentePactuado: 0,
      componenteGrupoFinanciamento: 0,
      dataIncorporacao: '',
      portariaIncorporacao: '',
      linkPortariaIncorporacao: '',
      dataDocumento: '',
      documentoTecnicoOrientadorTitulo: '',
      documentoTecnicoOrientadorLink: '',
      dataDesincorporacao: '',
      portariaDesincorporacao: '',
      linkPortariaDesincorporacao: '',
      statusPactuacao: 0,
      dataPactuacao: '',
      ataPactuacao: '',
      ataPactuacaoLink: '',
      observacoes: '',
    });
    setLogIncorporacaoData({
      ...logIncorporacaData,
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const handleClearFormOutroSistema = () => {
    setFormOutroSistema({
      id: '',
      usuarioId: userID,
      produtoDAFId: formProduto.id,
      outroSistema: 0,
      codigoProduto: '',
      nomeProduto: '',
      observacoes: '',
    });
    setLogIncorporacaoData({
      ...logIncorporacaData,
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const fetchOptions = async () => {
    try {
      const denominacoesGenericasData = await getAllDenominacoesGenericas();
      setdenominacaoGenericaData(denominacoesGenericasData);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
    }
  };

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID);
      fetchDataIncorporacao(fichaID);
      fetchDataOutroSistema(fichaID);
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasProdutosDaf(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `#`,
      },
    ];
  }

  // useEffect para buscar as opções ao carregar o componente
  useEffect(() => {
    fetchOptions();
  }, []);

  // useEffect para carregar os dados do produto quando a fichaID estiver disponível
  useEffect(() => {
    if (fichaID) {
      fetchData(fichaID);
    }
  }, [fichaID]);

  // useEffect para garantir que o denominacaoGenericaId esteja selecionado corretamente após o carregamento das opções
  useEffect(() => {
    if (
      formProduto.denominacaoGenericaId &&
      denominacoesGenericasOptions.length > 0
    ) {
      const matchingOption = denominacoesGenericasOptions.find(
        (option) => option.value === formProduto.denominacaoGenericaId,
      );

      if (
        matchingOption &&
        formProduto.denominacaoGenericaId !== matchingOption.value
      ) {
        // Atualiza o valor do select para refletir a opção correta, evitando loops
        setFormProduto((prev) => ({
          ...prev,
          denominacaoGenericaId: matchingOption.value,
        }));
      }
    }
  }, [denominacoesGenericasOptions]);

  // useEffect para atualizar o estilo com base no valor de statusDistribuicao
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  const [oncologicoStyle, setOncologicoStyle] = useState<React.CSSProperties>(
    {},
  );
  const [biologicoStyle, setBiologicoStyle] = useState<React.CSSProperties>({});
  const [, setSigtapStyle] = useState<React.CSSProperties>({});
  const [, setSismatStyle] = useState<React.CSSProperties>({});
  const [, setCatmatStyle] = useState<React.CSSProperties>({});
  const [, setObmStyle] = useState<React.CSSProperties>({});
  const [componenteBasicoStyle, setComponenteBasicoStyle] =
    useState<React.CSSProperties>({});
  const [componenteEstrategicoStyle, setComponenteEstrategicoStyle] =
    useState<React.CSSProperties>({});
  const [componenteEspecializadoStyle, setComponenteEspecializadoStyle] =
    useState<React.CSSProperties>({});
  const [usoHospitalarStyle, setUsoHospitalarStyle] =
    useState<React.CSSProperties>({});
  const [farmaciaPopularStyle, setFarmaciaPopular] =
    useState<React.CSSProperties>({});
  const [statusIncorporacaoStyle, setStatusIncorporacaoStyle] =
    useState<React.CSSProperties>({});
  const [statusPactuacaoStyle, setStatusPactuacaoStyle] =
    useState<React.CSSProperties>({});
  const [statusRenameStyle, setStatusRenameStyle] =
    useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const amarelo = '#faffb4dd';
    const azul = '#c6d5fff1';

    const newStatusStyle = {
      backgroundColor:
        checkValueStatus(formProduto.statusDistribuicao) === 1
          ? verde
          : vermelho,
    };
    setStatusStyle(newStatusStyle);

    const newOncologicoStyle = {
      backgroundColor: formProduto.oncologico === 'S' ? verde : vermelho,
    };
    setOncologicoStyle(newOncologicoStyle);

    const newBiologicoStyle = {
      backgroundColor: formProduto.biologico === 'S' ? verde : vermelho,
    };
    setBiologicoStyle(newBiologicoStyle);

    const newSigtapStyle = {
      backgroundColor: formProduto.sigtapPossui === 'S' ? verde : vermelho,
    };
    setSigtapStyle(newSigtapStyle);

    const newSismatStyle = {
      backgroundColor: formProduto.sismatPossui === 'S' ? verde : vermelho,
    };
    setSismatStyle(newSismatStyle);

    const newCatmatStyle = {
      backgroundColor: formProduto.catmatPossui === 'S' ? verde : vermelho,
    };
    setCatmatStyle(newCatmatStyle);

    const newObmStyle = {
      backgroundColor: formProduto.obmPossui === 'S' ? verde : vermelho,
    };
    setObmStyle(newObmStyle);

    const newComponenteBasicoStyle = {
      backgroundColor: formProduto.compBasico === 'S' ? verde : vermelho,
    };
    setComponenteBasicoStyle(newComponenteBasicoStyle);

    const newComponenteEstrategicoStyle = {
      backgroundColor: formProduto.compEstrategico === 'S' ? verde : vermelho,
    };
    setComponenteEstrategicoStyle(newComponenteEstrategicoStyle);

    const newComponenteEspecializadoStyle = {
      backgroundColor: formProduto.compEspecializado === 'S' ? verde : vermelho,
    };
    setComponenteEspecializadoStyle(newComponenteEspecializadoStyle);

    const newUsoHospitalarStyle = {
      backgroundColor: formProduto.usoHospitalar === 'S' ? verde : vermelho,
    };
    setUsoHospitalarStyle(newUsoHospitalarStyle);

    const newFarmaciaPopularStyle = {
      backgroundColor: formProduto.farmaciaPopular === 'S' ? verde : vermelho,
    };
    setFarmaciaPopular(newFarmaciaPopularStyle);

    const newStatusIncorporcaoStyle = {
      backgroundColor:
        formIncorporacao.statusIncorporacao === 1
          ? amarelo
          : formIncorporacao.statusIncorporacao === 2
            ? verde
            : formIncorporacao.statusIncorporacao === 3
              ? vermelho
              : 'white',
    };
    setStatusIncorporacaoStyle(newStatusIncorporcaoStyle);

    const newStatusPactuacaoStyle = {
      backgroundColor:
        formIncorporacao.statusPactuacao === 1
          ? vermelho
          : formIncorporacao.statusPactuacao === 2
            ? verde
            : 'white',
    };
    setStatusPactuacaoStyle(newStatusPactuacaoStyle);

    const statusRenameNumber = Number(formProduto.statusRename);
    const newStatusRenameStyle = {
      backgroundColor:
        statusRenameNumber === 1
          ? amarelo
          : statusRenameNumber === 2
            ? verde
            : statusRenameNumber === 3
              ? azul
              : statusRenameNumber === 4
                ? vermelho
                : 'white',
    };
    setStatusRenameStyle(newStatusRenameStyle);
  }, [
    formProduto.statusDistribuicao,
    formProduto.oncologico,
    formProduto.biologico,
    formProduto.sigtapPossui,
    formProduto.sismatPossui,
    formProduto.catmatPossui,
    formProduto.obmPossui,
    formProduto.compBasico,
    formProduto.compEstrategico,
    formProduto.compEspecializado,
    formProduto.usoHospitalar,
    formProduto.farmaciaPopular,
    formProduto.statusRename,
    formIncorporacao.statusIncorporacao,
    formIncorporacao.statusPactuacao,
  ]);

  // useEffect para monitorar o valor de sigtapPossui e ajustar readonly e valores
  const [, setIsCompEspecializadoReadOnly] = useState(false);
  useEffect(() => {
    if (
      formProduto.compEspecializado === 'N' ||
      formProduto.compEspecializado === ''
    ) {
      setIsCompEspecializadoReadOnly(true);
      setFormProduto((prev) => ({
        ...prev,
        especializadoGrupo: 4,
      }));
    } else {
      setIsCompEspecializadoReadOnly(false);
      setFormProduto((prev) => ({
        ...prev,
        especializadoGrupo: 0,
      }));
    }
  }, [formProduto.compEspecializado]);

  const [, setIsSigtapReadonly] = useState(false);
  useEffect(() => {
    if (checkValueStatus(formProduto.sigtapPossui) === 2) {
      setIsSigtapReadonly(true);
      setFormProduto((prev) => ({
        ...prev,
        sigtapCodigo: '',
        sigtapNome: '',
      }));
    } else {
      setIsSigtapReadonly(false);
    }
  }, [formProduto.sigtapPossui]);
  const [, setIsSismatReadonly] = useState(false);
  useEffect(() => {
    if (checkValueStatus(formProduto.sismatPossui) === 2) {
      setIsSismatReadonly(true);
      setFormProduto((prev) => ({
        ...prev,
        sismatCodigo: '',
        sismatNome: '',
      }));
    } else {
      setIsSismatReadonly(false);
    }
  }, [formProduto.sismatPossui]);
  const [, setIsCatmatReadonly] = useState(false);
  useEffect(() => {
    if (checkValueStatus(formProduto.catmatPossui) === 2) {
      setIsCatmatReadonly(true);
      setFormProduto((prev) => ({
        ...prev,
        catmatCodigo: '',
        catmatNome: '',
      }));
    } else {
      setIsCatmatReadonly(false);
    }
  }, [formProduto.catmatPossui]);
  const [, setIsObmReadonly] = useState(false);
  useEffect(() => {
    if (checkValueStatus(formProduto.obmPossui) === 2) {
      setIsObmReadonly(true);
      setFormProduto((prev) => ({
        ...prev,
        obmCodigo: '',
        obmNome: '',
      }));
    } else {
      setIsObmReadonly(false);
    }
  }, [formProduto.obmPossui]);
  const [isStatusIncorporacaoReadonly, setIsStatusIncorporacaoReadonly] =
    useState(false);

  const [isStatusEmIncorporacaoReadOnly, setIsStatusEmIncorporacaoReadOnly] =
    useState(false);

  useEffect(() => {
    let updatedForm = { ...formIncorporacao };

    if ([1, 2, 0].includes(formIncorporacao.statusIncorporacao)) {
      setIsStatusIncorporacaoReadonly(true);
      updatedForm = {
        ...updatedForm,

        dataDesincorporacao: '',
        portariaDesincorporacao: '',
        linkPortariaDesincorporacao: '',
      };
    } else {
      setIsStatusIncorporacaoReadonly(false);
    }

    if ([0, 1].includes(formIncorporacao.statusIncorporacao)) {
      setIsStatusEmIncorporacaoReadOnly(true);
      updatedForm = {
        ...updatedForm,
        dataIncorporacao: '',
        dataDocumento: '',
        portariaIncorporacao: '',
        linkPortariaIncorporacao: '',
        documentoTecnicoOrientador: 0,
        documentoTecnicoOrientadorTitulo: '',
        documentoTecnicoOrientadorLink: '',
        dataDesincorporacao: '',
        portariaDesincorporacao: '',
        linkPortariaDesincorporacao: '',
        dataPactuacao: '',
        statusPactuacao: 0,
        ataPactuacao: '',
        ataPactuacaoLink: '',
      };
    } else {
      setIsStatusEmIncorporacaoReadOnly(false);
    }

    // Atualiza o estado apenas se houver mudanças
    if (JSON.stringify(formIncorporacao) !== JSON.stringify(updatedForm)) {
      setFormIncorporacao(updatedForm);
    }
  }, [formIncorporacao.statusIncorporacao]);

  const generateProdutoFarmaceuticoName = (
    denominacao: string,
    concentracao: string,
    formaFarmaceutica: string,
  ) => {
    return `${denominacao || ''} ${concentracao || ''} ${formaFarmaceutica ? `(${formaFarmaceutica})` : ''}`.trim();
  };

  type FormProdutoFields = keyof typeof formProduto;
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    listenChange.current = true;

    setFormProduto((prev) => {
      const newState = { ...prev } as Record<FormProdutoFields, any>;

      // Buscar a denominação genérica pelo ID
      const selectedDenominacao = denominacaoGenericaData.find(
        (option) => option.id === prev.denominacaoGenericaId,
      );

      // Buscar a forma farmacêutica atual pelo ID
      const selectedFormaFarmaceutica = formaFarmaceutica.find(
        (option) => option.value === prev.formaFarmaceutica.toString(),
      );

      if (name === 'denominacaoGenerica') {
        const selectedOption = denominacoesGenericasOptions.find(
          (option) => option.value === parseInt(value, 10),
        );
        if (selectedOption && selectedFormaFarmaceutica) {
          newState.denominacaoGenericaId = selectedOption.value;
          newState.produtoFarmaceutico = generateProdutoFarmaceuticoName(
            selectedOption.label,
            prev.concentracao,
            selectedFormaFarmaceutica.label, // Mantém o label da forma farmacêutica atual
          );
        }
      } else if (name === 'concentracao') {
        newState.concentracao = value;
        if (selectedFormaFarmaceutica) {
          newState.produtoFarmaceutico = generateProdutoFarmaceuticoName(
            selectedDenominacao?.denominacaoGenerica || '',
            value,
            selectedFormaFarmaceutica.label, // Usa o label do select formaFarmaceutica
          );
        }
      } else if (name === 'formaFarmaceutica') {
        const selectedFormaFarmaceutica = formaFarmaceutica.find(
          (option) => option.value === value,
        );
        if (selectedFormaFarmaceutica) {
          const formaFarmaceuticaSimpNumero =
            FormaFarmaceuticaMatch[selectedFormaFarmaceutica.label] || 0;
          newState.formaFarmaceutica = parseInt(value, 10);
          newState.formaFarmaceuticaSimp = formaFarmaceuticaSimpNumero;
          newState.formaFarmaceuticaLabel = selectedFormaFarmaceutica.label;
          newState.produtoFarmaceutico = generateProdutoFarmaceuticoName(
            selectedDenominacao?.denominacaoGenerica || '',
            prev.concentracao,
            selectedFormaFarmaceutica.label,
          );
        }
      } else if (name === 'aware') {
        const selectedAware = classificacaoAware.find(
          (option) => option.value === value,
        );
        if (selectedAware) {
          if (value === '9999') {
            newState.aware = 0;
          } else {
            newState.aware = parseInt(value, 10);
          }
        }
      } else if (name === 'statusDistribuicao') {
        newState.statusDistribuicao = value === '1' ? 'S' : 'N';
      } else if (name === 'oncologico') {
        newState.oncologico = value === '1' ? 'S' : 'N';
      } else if (name === 'biologico') {
        newState.biologico = value === '1' ? 'S' : 'N';
      } else if (name === 'sigtapPossui') {
        newState.sigtapPossui = value === '1' ? 'S' : 'N';
      } else if (name === 'sismatPossui') {
        newState.sismatPossui = value === '1' ? 'S' : 'N';
      } else if (name === 'catmatPossui') {
        newState.catmatPossui = value === '1' ? 'S' : 'N';
      } else if (name === 'obmPossui') {
        newState.obmPossui = value === '1' ? 'S' : 'N';
      } else if (name === 'compBasico') {
        newState.compBasico = value === '1' ? 'S' : 'N';
      } else if (name === 'compEstrategico') {
        newState.compEstrategico = value === '1' ? 'S' : 'N';
      } else if (name === 'compEspecializado') {
        newState.compEspecializado = value === '1' ? 'S' : 'N';
      } else if (name === 'usoHospitalar') {
        newState.usoHospitalar = value === '1' ? 'S' : 'N';
      } else if (name === 'farmaciaPopular') {
        newState.farmaciaPopular = value === '1' ? 'S' : 'N';
      } else {
        // Lógica padrão para outros campos
        newState[name as FormProdutoFields] = value;
      }

      if (name === 'statusRename') {
        if (value === '1') {
          newState.dataRenamePublicacao = '';
          newState.dataRenameAmpliacao = '';
          newState.dataRenameExclusao = '';
        }

        if (value === '2') {
          newState.dataRenameAmpliacao = '';
          newState.dataRenameExclusao = '';
        }

        if (value === '3') {
          newState.dataRenameExclusao = '';
        }
      }

      return newState;
    });
  };

  const validateForm = (formProduto: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!formProduto.denominacaoGenericaId) {
      errors.push('<b>Denominação Genérica</b> é obrigatório.');
    }

    if (!formProduto.formaFarmaceutica) {
      errors.push('<b>Forma Farmacêutica</b> é obrigatória.');
    }

    if (!formProduto.concentracao) {
      errors.push('<b>Concentração</b> é obrigatória.');
    }

    if (!formProduto.aware) {
      errors.push('Classificação <b>AwARE</b> é obrigatório.');
    }

    if (!formProduto.umidade) {
      errors.push('<b>Umidade</b> do produto é obrigatório.');
    }

    if (!formProduto.acondicionamento) {
      errors.push('<b>Acondicionamento</b> do produto é obrigatório.');
    }

    if (formProduto.statusRename === '2') {
      if (!formProduto.dataRenamePublicacao) {
        errors.push('<b>Data da Publicação na Rename</b> é obrigatório.');
      }
    }

    if (formProduto.statusRename === '3') {
      if (!formProduto.dataRenamePublicacao) {
        errors.push('<b>Data da Publicação na Rename</b> é obrigatório.');
      }

      if (!formProduto.dataRenameAmpliacao) {
        errors.push('<b>Data da Ampliação de Uso na Rename</b> é obrigatório.');
      }
    }

    if (formProduto.statusRename === '4') {
      if (!formProduto.dataRenamePublicacao) {
        errors.push('<b>Data da Publicação na Rename</b> é obrigatório.');
      }

      if (!formProduto.dataRenameAmpliacao) {
        errors.push('<b>Data da Ampliação de Uso na Rename</b> é obrigatório.');
      }

      if (!formProduto.dataRenameExclusao) {
        errors.push('<b>Data da Exclusão na Rename</b> é obrigatório.');
      }
    }

    if (formProduto.sigtapPossui === 'S') {
      if (!formProduto.sigtapCodigo) {
        errors.push('<b>Código da SIGTAP</b> é obrigatório.');
      }

      if (!formProduto.sigtapNome) {
        errors.push('<b>Nome da SIGTAP</b> é obrigatório.');
      }
    }

    if (formProduto.sismatPossui === 'S') {
      if (!formProduto.sismatCodigo) {
        errors.push('<b>Código do SISMAT</b> é obrigatório.');
      }

      if (!formProduto.sismatNome) {
        errors.push('<b>Nome do SISMAT</b> é obrigatório.');
      }
    }

    if (formProduto.catmatPossui === 'S') {
      if (!formProduto.catmatCodigo) {
        errors.push('<b>Código do SISMAT</b> é obrigatório.');
      }

      if (!formProduto.catmatNome) {
        errors.push('<b>Nome do SISMAT</b> é obrigatório.');
      }
    }

    if (formProduto.obmPossui === 'S') {
      if (!formProduto.obmCodigo) {
        errors.push('<b>Código da OBM</b> é obrigatório.');
      }

      if (!formProduto.obmNome) {
        errors.push('<b>Nome da OBM</b> é obrigatório.');
      }
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const validateFormIncorporacao = (formIncorporacao: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (formIncorporacao.statusIncorporacao === 0) {
      errors.push('<b>Status da Incorporação</b> é obrigatória.');
    }

    // Status === INCORPORADO
    if (
      formIncorporacao.statusIncorporacao === 2 ||
      formIncorporacao.statusIncorporacao === 3
    ) {
      if (formIncorporacao.dataIncorporacao === '') {
        errors.push('<b>Data da Incorporação</b> é obrigatória.');
      }

      if (formIncorporacao.portariaIncorporacao === '') {
        errors.push('Nº da <b>Portaria de Incorporação</b> é obrigatória.');
      }

      if (formIncorporacao.statusPactuacao === 0) {
        errors.push('<b>Status de Pactuação</b> é obrigatório.');
      }
    }

    // Status === PACTUADO
    if (formIncorporacao.statusPactuacao === 2) {
      if (formIncorporacao.dataPactuacao === '') {
        errors.push('<b>Data da Pactuação</b> é obrigatória.');
      }

      if (formIncorporacao.ataPactuacao === '') {
        errors.push('<b>Nº da Ata de Pactuação</b> é obrigatória.');
      }

      if (formIncorporacao.componentePactuado === 0) {
        errors.push('<b>Componente AF</b> é obrigatório.');
      }
    }

    if (formIncorporacao.componentePactuado === 2) {
      if (formIncorporacao.componenteGrupoFinanciamento === '') {
        errors.push('<b>Grupo de Financiamento</b> é obrigatório.');
      }
    }

    // Status === DESINCORPORADO
    if (formIncorporacao.statusIncorporacao === 3) {
      if (formIncorporacao.dataDesincorporacao === '') {
        errors.push('<b>Data da Desincorporação</b> é obrigatória.');
      }

      if (formIncorporacao.portariaDesincorporacao === '') {
        errors.push('Nº da <b>Portaria de Desincorporação</b> é obrigatória.');
      }

      if (formIncorporacao.linkPortariaDesincorporacao === '') {
        errors.push(
          '<b>Link da Portaria de Desincorporação</b> é obrigatório.',
        );
      }
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const adjustFormBeforeSubmit = (formProduto: any) => {
    const formProdutoWithoutTags = { ...formProduto };
    delete formProdutoWithoutTags.tags;
    delete formProdutoWithoutTags.tagsArray;
    delete formProdutoWithoutTags.id;
    delete formProdutoWithoutTags.formaFarmaceuticaLabel;

    return {
      ...formProdutoWithoutTags,
      // Adicione ajustes necessários aqui
      statusDistribuicao: formProduto.statusDistribuicao || 'N',
      statusRename: Number(formProduto.statusRename),
      dataRenamePublicacao: formProduto.dataRenamePublicacao
        ? formProduto.dataRenamePublicacao
        : null,
      dataRenameAmpliacao: formProduto.dataRenameAmpliacao
        ? formProduto.dataRenameAmpliacao
        : null,
      dataRenameExclusao: formProduto.dataRenameExclusao
        ? formProduto.dataRenameExclusao
        : null,
      oncologico: formProduto.oncologico || 'N',
      biologico: formProduto.biologico || 'N',
      umidade: parseInt(formProduto.umidade),
      acondicionamento: parseInt(formProduto.acondicionamento),
      compBasico: formProduto.compBasico || 'N',
      compEspecializado: formProduto.compEspecializado || 'N',
      compEstrategico: formProduto.compEstrategico || 'N',
      especializadoGrupo: parseInt(formProduto.especializadoGrupo) || 4,
      usoHospitalar: formProduto.usoHospitalar || 'N',
      farmaciaPopular: formProduto.farmaciaPopular || 'N',
      sigtapPossui: formProduto.sigtapPossui || 'N',
      sismatPossui: formProduto.sismatPossui || 'N',
      catmatPossui: formProduto.catmatPossui || 'N',
      obmPossui: formProduto.obmPossui || 'N',
      observacoes: formProduto.observacoes || 'Nenhuma observação específica.',
    };
  };

  const handleProdutoCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formProduto);
      if (!isFormValid) return;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormBeforeSubmit(formProduto);

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/produtodaf/`, adjustedForm);
      clearAllCache(CACHE_KEY); // Limpa o cache
      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/produtosdaf/produtos/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleProdutoUpdate = async () => {
    // Verificar se houve mudança
    if (!listenChange.current) {
      checkListenChange(listenChange.current);
      return;
    }
    try {
      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormBeforeSubmit(formProduto);

      // Verificar se o formulário é válido
      const isFormValid = validateForm(formProduto);
      if (!isFormValid) return 'Erro no form do Produto DAF';

      const response = await httpClient.patch(
        `/api/produtodaf/${fichaID}`,
        adjustedForm,
      );
      clearAllCache(CACHE_KEY); // Limpa o cache
      swalSave();
      fetchData(response.data.registroAtualizado.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleProdutoDelete = async () => {
    let kits = null;
    try {
      kits = await getKitDeProdutoPorProdutoId(fichaID);
    } catch (error) {
      kits = null;
    }

    if (kits != null) {
      swalErro(
        'Não é possível deletar um produto associado<br> a um <b>Kit de Produtos DAF!</b>',
      );
      return; // Interrompe a execução se houver kits associados
    }

    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(`/api/produtodaf/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/produtosdaf/produtos');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    }
  };

  // Mantenha o estado como um array de números (IDs)
  const [selectedTags, setSelectedTags] = useState<number[]>([]);

  // Atualiza o formProduto com as tags selecionadas
  const handleTagsChange = (tagIds: number[]) => {
    setSelectedTags(tagIds);
    setFormProduto((prev) => ({
      ...prev,
      tagsArray: tagIds.includes(9999)
        ? [] // Se "Nenhuma tag" estiver selecionada, limpa as tags
        : tagsProdutos.filter((tag) => tagIds.includes(tag.id)), // Filtra tags selecionadas
    }));
  };

  const handleCreateTags = async () => {
    try {
      const produtoDAFId = formProduto.id;

      // selectedTags já contém os IDs das tags, então você pode usar diretamente
      const tagIds = selectedTags;

      // Log para verificar o payload
      // console.log('Payload:', { produtoDAFId, tags: tagIds });

      // Chama o serviço de salvar as tags, enviando os IDs
      await saveTags(produtoDAFId, tagIds);
      clearAllCache(CACHE_KEY); // Limpa o cache
      swalSave();
    } catch (error) {
      console.error('Erro ao salvar as tags:', error);
    }

    fetchData(fichaID); // Chama a função para buscar dados quando o comp
  };

  //INCORPORACAO
  const handleChangeIncorporacao = (event: any) => {
    const { name, value } = event.target;
    const parsedFields = [
      'statusIncorporacao',
      'statusPactuacao',
      'componenteAF',
      'documentoTecnicoOrientador',
    ];

    if (name === 'dataDesincorporacao') {
      if (
        formIncorporacao.dataDesincorporacao < formIncorporacao.dataIncorporacao
      ) {
        swalAttention(
          'A <b>Data da Desincorporação</b> não pode ser anterior à <b>Data da Incorporação</b>.',
        );
        formIncorporacao.dataDesincorporacao = '';
        return;
      }
    }

    if (name === 'dataPactuacao') {
      if (formIncorporacao.dataIncorporacao < formIncorporacao.dataPactuacao) {
        swalAttention(
          'A <b>Data da Pactuação</b> não pode ser anterior à <b>Data da Incorporação</b>.',
        );
        formIncorporacao.dataPactuacao = '';
        return;
      }
    }

    setFormIncorporacao((prev) => ({
      ...prev,
      [name]: parsedFields.includes(name) ? parseInt(value, 10) : value,
    }));
  };

  const adjustFormIncorporacaoBeforeSubmit = (formIncorporacao: any) => {
    const adjustedForm = {
      ...formIncorporacao,
      produtoDAFId: formProduto.id,
      documentoOrientador: formIncorporacao.documentoOrientador
        ? parseInt(formIncorporacao.documentoOrientador)
        : 0,
      statusPactuacao: formIncorporacao.statusPactuacao
        ? parseInt(formIncorporacao.statusPactuacao)
        : 0,
      componentePactuado: formIncorporacao.componentePactuado
        ? parseInt(formIncorporacao.componentePactuado)
        : 0,
      componenteGrupoFinanciamento:
        formIncorporacao.componenteGrupoFinanciamento
          ? parseInt(formIncorporacao.componenteGrupoFinanciamento)
          : 0,
      // Manter as datas como strings sem qualquer conversão
      dataIncorporacao: formIncorporacao.dataIncorporacao || null,
      dataDesincorporacao: formIncorporacao.dataDesincorporacao || null,
      dataDocumento: formIncorporacao.dataDocumento || null,
      dataPactuacao: formIncorporacao.dataPactuacao || null,
    };

    return adjustedForm;
  };

  const handleCreateIncorporacao = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateFormIncorporacao(formIncorporacao);
      if (!isFormValid) return false;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormIncorporacaoBeforeSubmit(formIncorporacao);

      // const token = 'JWT_SECRET';

      await httpClient.post(`/api/produtodafincorporacaosus/`, adjustedForm);
      clearAllCache(CACHE_KEY); // Limpa o cache
      swalSave();
      fetchDataIncorporacao(fichaID);
      // setTimeout(() => handleShowModalTramitacao(), 2000);
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdateIncorporacao = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateFormIncorporacao(formIncorporacao);
      if (!isFormValid) return false;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormIncorporacaoBeforeSubmit(formIncorporacao);

      // const token = 'JWT_SECRET';

      console.log(adjustedForm);

      // Salvar a atualização
      await httpClient.patch(
        `/api/produtodafincorporacaosus/${formIncorporacao.id}`,
        adjustedForm,
      );
      swalSave();

      // Busca os dados atualizados diretamente após a atualização
      await fetchDataIncorporacao(fichaID);
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  useEffect(() => {
    if (incorporacoesData.length > 0) {
      const filteredItem = incorporacoesData.find(
        (item) => item.id === formIncorporacao.id,
      );
      if (filteredItem && filteredItem.id !== formIncorporacao.id) {
        setDadosIncorporacao(filteredItem);
      }
    }
  }, [incorporacoesData, formIncorporacao.id]);

  const handleDeleteIncorporacao = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(
          `/api/produtodafincorporacaosus/${incorporacaoId}`,
        );
        swalDeleteConfirm();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    }
  };

  const [incorporacaoId, setIncorporacaoId] = useState<string>('');
  const handleRowClickIncorporacao = (id: string) => {
    setIncorporacaoId(id);
    setUpdatingIncorporacao(true);
    handleShowModalIncorporacao();
    const filteredItem = incorporacoesData.find((item) => item.id == id);

    if (filteredItem) {
      setDadosIncorporacao(filteredItem);
    }
  };

  const setDadosIncorporacao = (item: any) => {
    console.log(item);
    console.log(formIncorporacao);
    setFormIncorporacao({
      id: item.id,
      usuarioId: userID,
      produtoDAFId: formProduto.id,
      statusIncorporacao: item.statusIncorporacao,
      componentePactuado: item.componentePactuado,
      componenteGrupoFinanciamento: item.componenteGrupoFinanciamento,
      documentoTecnicoOrientador: item.documentoTecnicoOrientador,
      dataIncorporacao: item.dataIncorporacao,
      portariaIncorporacao: item.portariaIncorporacao,
      linkPortariaIncorporacao: item.linkPortariaIncorporacao,
      dataDocumento: item.dataDocumento,
      documentoTecnicoOrientadorTitulo: item.documentoTecnicoOrientadorTitulo,
      documentoTecnicoOrientadorLink: item.documentoTecnicoOrientadorLink,
      dataDesincorporacao: item.dataDesincorporacao,
      portariaDesincorporacao: item.portariaDesincorporacao,
      linkPortariaDesincorporacao: item.linkPortariaDesincorporacao,
      statusPactuacao: item.statusPactuacao,
      dataPactuacao: item.dataPactuacao,
      ataPactuacao: item.ataPactuacao,
      ataPactuacaoLink: item.ataPactuacaoLink,
      observacoes: item.observacoes,
    });
    setLogIncorporacaoData({
      id: item.id,
      usuarioRegistro: item.usuarioRegistro.nomeCompleto || '',
      usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto || '',
      dataRegistro: item.dataRegistro,
      dataAtualizacao: item.dataUltimaAtualizacao,
      nEdicoes: item.nEdicoes,
    });
    console.log(formIncorporacao);
  };

  //Adicionais
  const larguraDisponivel = useCalculaPercentualDisponivel('170px', '50%');

  const theme = useTheme();

  //Modal Tags
  const [showModalTags, setShowModalTags] = useState<boolean>(false);
  const handleShowModalTags = () => {
    setShowModalTags((show) => !show);
  };

  const [isComponentePactuadoReadOnly, setIsComponentePactuadoReadOnly] =
    useState(false);

  useEffect(() => {
    let updatedForm = { ...formIncorporacao };
    if (Number(formIncorporacao.componentePactuado) == 2) {
      setIsComponentePactuadoReadOnly(true);
    } else {
      setIsComponentePactuadoReadOnly(false);
      updatedForm = {
        ...updatedForm,
        componenteGrupoFinanciamento: 0,
      };
    }
    // Atualiza o estado apenas se houver mudanças
    if (JSON.stringify(formIncorporacao) !== JSON.stringify(updatedForm)) {
      setFormIncorporacao(updatedForm);
    }
  }, [formIncorporacao.componentePactuado]);

  const [isPactuacaoReadOnly, setIsPactuacaoReadOnly] = useState(false);

  useEffect(() => {
    let updatedForm = { ...formIncorporacao };
    if (formIncorporacao.statusPactuacao === 2) {
      setIsPactuacaoReadOnly(true);
    } else {
      setIsPactuacaoReadOnly(false);
      updatedForm = {
        ...updatedForm,

        dataPactuacao: '',
        ataPactuacao: '',
        ataPactuacaoLink: '',
        componentePactuado: 0,
        componenteGrupoFinanciamento: 0,
      };
    }

    // Atualiza o estado apenas se houver mudanças
    if (JSON.stringify(formIncorporacao) !== JSON.stringify(updatedForm)) {
      setFormIncorporacao(updatedForm);
    }
  }, [formIncorporacao.statusPactuacao]);

  useEffect(() => {
    if (showModalTags) {
      // Carrega as tags salvas do formProduto.tagsArray
      const inicialTags =
        formProduto.tagsArray.length > 0
          ? formProduto.tagsArray.map((tag) => tag.id) // Carrega os IDs das tags salvas
          : [9999]; // Se estiver vazio, seleciona "Nenhuma tag"

      setSelectedTags(inicialTags);
    }
  }, [showModalTags, formProduto.tagsArray]);

  const [initialFormProduto] = useState(formProduto);
  const [initialFormIncorporacao] = useState(formIncorporacao);

  const [, setIsProdutoChanged] = useState(false);
  const [, setIsIncorporacaoChanged] = useState(false);

  useEffect(() => {
    setIsProdutoChanged(
      JSON.stringify(initialFormProduto) !== JSON.stringify(formProduto),
    );
  }, [formProduto, initialFormProduto]);

  useEffect(() => {
    setIsIncorporacaoChanged(
      JSON.stringify(initialFormIncorporacao) !==
        JSON.stringify(formIncorporacao),
    );
  }, [formIncorporacao, initialFormIncorporacao]);

  // const handleSave = async () => {
  //   if (!fichaID || fichaID === 'undefined') {
  //     // Criar apenas o Produto se não há fichaID
  //     await handleProdutoCreate();
  //   } else {
  //     // Atualizações condicionais
  //     if (isProdutoChanged && isIncorporacaoChanged) {
  //       const isFormProdutoValid = validateForm(formProduto);
  //       if (!isFormProdutoValid) return;

  //       const isFormIncorporacaoValid =
  //         validateFormIncorporacao(formIncorporacao);
  //       if (!isFormIncorporacaoValid) {
  //         return;
  //       }

  //       const produtoUpdateSuccess = await handleProdutoUpdate();

  //       if (produtoUpdateSuccess != 'Erro no form do Produto DAF') {
  //         if (isIncorporacaoChanged) {
  //           await handleCreateIncorporacao();
  //           swalSave();
  //         } else {
  //           swalSave();
  //         }
  //       }
  //     } else if (isProdutoChanged) {
  //       await handleProdutoUpdate();
  //     } else if (isIncorporacaoChanged) {
  //       await handleCreateIncorporacao();
  //     } else {
  //       swalAttention('Não houve mudanças para salvar.');
  //     }
  //   }
  // };

  //OUTRO SISTEMA
  const handleChangeOutroSistema = (event: any) => {
    const { name, value } = event.target;
    const parsedFields = ['outroSistema'];

    setFormOutroSistema((prev) => ({
      ...prev,
      [name]: parsedFields.includes(name) ? parseInt(value, 10) : value,
    }));
  };

  const validateFormOutroSistema = (formOutroSistema: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (formOutroSistema.outroSistema === 0) {
      errors.push('<b>Sistema</b> é obrigatório.');
    }

    if (formOutroSistema.codigoProduto === 0) {
      errors.push('<b>Código do Produto</b> é obrigatório.');
    }

    if (formOutroSistema.nomeProduto === 0) {
      errors.push('<b>Nome do Produto</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const adjustFormOutroSistemaBeforeSubmit = (formOutroSistema: any) => {
    const adjustedForm = {
      ...formOutroSistema,
      produtoDAFId: formProduto.id,
      outroSistema: Number(formOutroSistema.outroSistema),
      codigoProduto: formOutroSistema.codigoProduto,
      nomeProduto: formOutroSistema.nomeProduto,
      observacoes: formOutroSistema.observacoes
        ? formOutroSistema.observacoes
        : 'Sem observações.',
    };

    return adjustedForm;
  };

  const handleCreateOutroSistema = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateFormOutroSistema(formOutroSistema);
      if (!isFormValid) return false;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormOutroSistemaBeforeSubmit(formOutroSistema);

      // const token = 'JWT_SECRET';

      await httpClient.post(`/api/produtooutrosistema/`, adjustedForm);

      swalSave();
      fetchDataOutroSistema(fichaID);
      // setTimeout(() => handleShowModalTramitacao(), 2000);
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdateOutroSistema = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateFormOutroSistema(formOutroSistema);
      if (!isFormValid) return false;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormOutroSistemaBeforeSubmit(formOutroSistema);

      // const token = 'JWT_SECRET';

      console.log(adjustedForm);

      // Salvar a atualização
      await httpClient.patch(
        `/api/produtooutrosistema/${formOutroSistema.id}`,
        adjustedForm,
      );
      swalSave();

      // Busca os dados atualizados diretamente após a atualização
      await fetchDataOutroSistema(fichaID);
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  useEffect(() => {
    if (outroSistemaData.length > 0) {
      const filteredItem = outroSistemaData.find(
        (item) => item.id === formOutroSistema.id,
      );
      if (filteredItem && filteredItem.id !== formOutroSistema.id) {
        setDadosIncorporacao(filteredItem);
      }
    }
  }, [outroSistemaData, formOutroSistema.id]);

  const handleDeleteOutroSistema = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(`/api/produtooutrosistema/${outroSistemaId}`);
        swalDeleteConfirm();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    }
  };

  const [outroSistemaId, setOutroSistemaId] = useState<string>('');
  const handleRowClickOutroSistema = (id: string) => {
    setOutroSistemaId(id);
    setUpdatingOutroSistema(true);
    handleShowModalOutroSistema();
    const filteredItem = outroSistemaData.find((item) => item.id == id);

    if (filteredItem) {
      setDadosOutrosistema(filteredItem);
    }
  };

  const setDadosOutrosistema = (item: any) => {
    setFormOutroSistema({
      id: item.id,
      usuarioId: userID,
      produtoDAFId: formProduto.id,
      outroSistema: item.outroSistema,
      codigoProduto: item.codigoProduto,
      nomeProduto: item.nomeProduto,
      observacoes: item.observacoes,
    });
    setLogOutroSistemaData({
      id: item.id,
      usuarioRegistro: item.usuarioRegistro.nomeCompleto || '',
      usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto || '',
      dataRegistro: item.dataRegistro,
      dataAtualizacao: item.dataUltimaAtualizacao,
      nEdicoes: item.nEdicoes,
    });
  };

  // Relatorio
  // const relatorioRef = useRef<HTMLDivElement>(null);
  // Função para enviar os dados do relatório à API
  // const inserirRelatorio = async () => {
  //   const relatorioData = {
  //     coUsuarioRegistro: 1, // ID do usuário que realizou o registro
  //     coUsuarioVisualizacao: 2, // ID do usuário que realizou a última visualização
  //     dtRegistro: new Date().toISOString(), // Data de registro do relatório
  //     dtUltimaVisualizacao: new Date().toISOString(), // Data da última visualização
  //     nuVisualizacao: 10, // Número total de visualizações
  //     nuVisualizador: 5, // Número de visualizadores únicos
  //     dtRelatorioGerado: new Date().toISOString().split('T')[0], // Data em que o relatório foi gerado (YYYY-MM-DD)
  //     dsTitulo: 'Relatório de Produto Farmacêutico',
  //     dsTemplate: 'tpProdutoDaf001', // Nome do template
  //     dsDadosRelatorio: JSON.stringify({
  //       key1: 'value1',
  //       key2: 'value2',
  //     }), // Dados do relatório em formato JSON
  //     dsObservacao: 'Observação do relatório', // Observação opcional
  //     stRegistroAtivo: 'S', // Status do relatório (ativo ou não)
  //   };

  //   try {
  //     const token = localStorage.getItem('token');
  //     await axios.post(
  //       `${process.env.REACT_APP_API_URL}/api/relatorios`,
  //       relatorioData,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       },
  //     );
  //   } catch (error: unknown) {
  //     if (axios.isAxiosError(error)) {
  //       console.error(
  //         'Erro ao enviar relatório:',
  //         error.response?.data || error.message,
  //       );
  //     } else if (error instanceof Error) {
  //       console.error(
  //         'Erro desconhecido ao tentar enviar o relatório:',
  //         error.message,
  //       );
  //     } else {
  //       console.error('Erro inesperado ao tentar enviar o relatório:', error);
  //     }
  //   }
  // };
  //Gerar PDF
  // const gerarPDF = async () => {
  //   const element = relatorioRef.current;
  //   if (!element) return;

  //   try {
  //     // Inserir os dados antes de gerar o PDF
  //     await inserirRelatorio();

  //     // Gerar o PDF
  //     const canvas = await html2canvas(element, { scale: 2 });
  //     const imgData = canvas.toDataURL('image/png');

  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     const imgHeight = (canvas.height * pageWidth) / canvas.width;

  //     let position = 0;

  //     while (position < imgHeight) {
  //       const remainingHeight = imgHeight - position;

  //       if (remainingHeight <= pageHeight) {
  //         pdf.addImage(
  //           imgData,
  //           'PNG',
  //           0,
  //           0,
  //           pageWidth,
  //           (remainingHeight * pageWidth) / canvas.width,
  //         );
  //         break;
  //       } else {
  //         pdf.addImage(imgData, 'PNG', 0, -position, pageWidth, pageHeight);
  //         position += pageHeight;
  //         pdf.addPage();
  //       }
  //     }

  //     pdf.save('relatorio_produto.pdf');
  //   } catch (error) {
  //     console.error('Erro ao gerar o PDF:', error);
  //   }
  // };

  const [showRelatorio, setShowRelatorio] = useState(false);

  const handleShowRelatorio = () => setShowRelatorio(!showRelatorio);

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/produtosdaf/produtos"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <span className="material-icons">arrow_back</span>
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} />

          <BoxConteudo boxTitulo="Dados do Produto Farmacêutico">
            {/* Produto Farmacêutico */}
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="155px">
                <SelectInput
                  name="statusDistribuicao"
                  options={statusBin}
                  label="Status Distribuição"
                  value={checkValueStatus(formProduto.statusDistribuicao) || ''}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="produto"
                  value={formProduto.produtoFarmaceutico}
                  id="cpf"
                  label="Produto Farmacêutico"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
            </CustomRow>

            {/* Denominação Genérica */}
            <CustomRow>
              {/* Tipo de Produto */}
              <CustomCol width="155px">
                <Input
                  name="tipoProduto"
                  value={
                    tipoProduto.find(
                      (option) =>
                        parseInt(option.value, 10) ===
                        denominacaoGenericaData.find(
                          (denom) =>
                            denom.id === formProduto.denominacaoGenericaId,
                        )?.tipoProduto,
                    )?.label || ''
                  }
                  id="tipoProduto"
                  label="Tipo de Produto"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>

              {/* Denominação Genérica */}
              <CustomCol>
                <SelectInput
                  name="denominacaoGenerica"
                  options={denominacoesGenericasOptions}
                  label="Denominação Genérica"
                  value={formProduto.denominacaoGenericaId || 'Não informado'}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              {/* Concentração/Dose */}
              <CustomCol width={larguraDisponivel}>
                <Input
                  name="concentracao"
                  value={formProduto.concentracao}
                  id="concentracao"
                  label="Concentração/Dose"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
            </CustomRow>

            {/* Forma farmacêutica */}
            <CustomRow>
              {/* Forma Farmacêutica */}
              <CustomCol>
                <SelectInput
                  name="formaFarmaceutica"
                  options={formaFarmaceutica}
                  label="Forma Farmacêutica"
                  value={formProduto.formaFarmaceutica}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              {/* Classificação Aware */}
              <CustomCol width="200px">
                <SelectInput
                  name="aware"
                  options={classificacaoAware}
                  label="AwARE"
                  value={formProduto.aware}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              {/* Umidade */}
              <CustomCol width="200px">
                <SelectInput
                  name="umidade"
                  options={umidade}
                  label="Umidade do Produto"
                  value={formProduto.umidade}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              {/* Acondicionamento */}
              <CustomCol width="200px">
                <SelectInput
                  name="acondicionamento"
                  options={acondicionamento}
                  label="Acondicionamento"
                  value={formProduto.acondicionamento}
                  onChange={handleChange}
                  required
                />
              </CustomCol>

              <CustomCol width="7%">
                <SelectInput
                  name="oncologico"
                  options={statusBin}
                  label="Oncológico"
                  value={checkValueStatus(formProduto.oncologico) || ''}
                  onChange={handleChange}
                  style={oncologicoStyle}
                />
              </CustomCol>
              <CustomCol width="7%">
                <SelectInput
                  name="biologico"
                  options={statusBin}
                  label="Biológico"
                  value={checkValueStatus(formProduto.biologico) || ''}
                  onChange={handleChange}
                  style={biologicoStyle}
                />
              </CustomCol>
            </CustomRow>

            {/* Rename */}
            <CustomRow style={{ justifyContent: 'flex-start' }}>
              <CustomCol width="268px">
                <SelectInput
                  name="statusRename"
                  options={statusRename}
                  label="Status RENAME"
                  value={formProduto.statusRename}
                  onChange={handleChange}
                  style={statusRenameStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataRenamePublicacao"
                  label="Data de Publicação"
                  value={formProduto.dataRenamePublicacao}
                  id="tags"
                  type="date"
                  onChange={handleChange}
                  readonly={
                    Number(formProduto.statusRename) == 2 ||
                    Number(formProduto.statusRename) == 3 ||
                    Number(formProduto.statusRename) == 4
                      ? false
                      : true
                  }
                  required={
                    Number(formProduto.statusRename) == 2 ||
                    Number(formProduto.statusRename) == 3 ||
                    Number(formProduto.statusRename) == 4
                      ? true
                      : false
                  }
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataRenameAmpliacao"
                  label="Data de Ampliação do Uso"
                  value={formProduto.dataRenameAmpliacao}
                  id="dataRenameAmpliacao"
                  type="date"
                  onChange={handleChange}
                  readonly={
                    Number(formProduto.statusRename) == 3 ||
                    Number(formProduto.statusRename) == 4
                      ? false
                      : true
                  }
                  required={
                    Number(formProduto.statusRename) == 3 ||
                    Number(formProduto.statusRename) == 4
                      ? true
                      : false
                  }
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataRenameExclusao"
                  label="Data de Exclusão"
                  value={formProduto.dataRenameExclusao}
                  id="tags"
                  type="date"
                  onChange={handleChange}
                  readonly={
                    Number(formProduto.statusRename) == 4 ? false : true
                  }
                  required={
                    Number(formProduto.statusRename) == 4 ? true : false
                  }
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="codigoAtc"
                  value={
                    formProduto.codigoAtc === null
                      ? 'Não informado'
                      : formProduto.codigoAtc
                  }
                  id="codigoAtc"
                  label="ATC"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>

            {/* Componentes AF */}
            <CustomRow style={{ justifyContent: 'flex-start' }}>
              <CustomCol width="200px">
                <Input
                  name="compBasico"
                  value={formProduto.compBasico === 'S' ? 'Sim' : 'Não'}
                  id="compEspecializado"
                  label="Comp. AF - Básico"
                  onChange={handleChange}
                  style={componenteBasicoStyle}
                  readonly
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="compEspecializado"
                  value={formProduto.compEspecializado === 'S' ? 'Sim' : 'Não'}
                  id="compEspecializado"
                  label="Comp. AF - Especializado"
                  onChange={handleChange}
                  style={componenteEspecializadoStyle}
                  readonly
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="especializadoGrupo"
                  value={
                    formProduto.especializadoGrupo !== undefined &&
                    grupoFinanciamento.hasOwnProperty(
                      formProduto.especializadoGrupo,
                    )
                      ? grupoFinanciamento[formProduto.especializadoGrupo].label
                      : 'Não informado'
                  }
                  id="especializadoGrupo"
                  label="Grupo Financiamento"
                  onChange={handleChange}
                  readOnly
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="compEstrategico"
                  value={formProduto.compEstrategico === 'S' ? 'Sim' : 'Não'}
                  id="compEstrategico"
                  label="Comp. AF - Estratégico"
                  onChange={handleChange}
                  style={componenteEstrategicoStyle}
                  readonly
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="usoHospitalar"
                  options={statusBin}
                  label="Uso Hospitalar?"
                  value={checkValueStatus(formProduto.usoHospitalar) || ''}
                  onChange={handleChange}
                  style={usoHospitalarStyle}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="farmaciaPopular"
                  options={statusBin}
                  label="Disp. Farmácia Popular?"
                  value={checkValueStatus(formProduto.farmaciaPopular) || ''}
                  onChange={handleChange}
                  style={farmaciaPopularStyle}
                />
              </CustomCol>
            </CustomRow>

            {/* Tags do Produto */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="tags"
                  label="Tags do Produto"
                  value={formProduto.tags}
                  id="tags"
                  onChange={handleChange}
                  readonly
                  type="textarea"
                />
              </CustomCol>
              <CustomCol
                width="100px"
                style={{ alignSelf: 'flex-end', marginBottom: '10px' }}
              >
                <CustomButton
                  label="Editar"
                  bgColor={theme.colors.amarelogov}
                  textColor="#ffffff" // Texto branco
                  onClick={handleShowModalTags}
                />
              </CustomCol>

              <Modal
                icone={'tag'}
                tituloModal={'Tags do Produto'}
                open={showModalTags}
                onHide={handleShowModalTags}
              >
                <WorkspaceFicha>
                  {/* <Log {...logs} /> */}
                  <BoxConteudo boxTitulo="">
                    <CheckBoxList
                      opcoes={tagsProdutos}
                      opcoesSelecionadas={selectedTags}
                      isOpen={showModalTags}
                      onChange={handleTagsChange}
                    />
                    ;
                  </BoxConteudo>

                  <BarraInferiorBotoes>
                    <WorkspaceBotoes save onClickSave={handleCreateTags} />
                  </BarraInferiorBotoes>
                </WorkspaceFicha>
              </Modal>
            </CustomRow>
          </BoxConteudo>

          {/* Incorporações SUS */}
          <BoxConteudo boxTitulo="Incorporações do Produto na Política de Assistência Farmacêutica">
            <CustomCol width="100%">
              <Tabela
                headers={headersIncoporacao}
                dataTable={tableDataIncorporacoes}
                displayValues={valoresExibidosIncorporacao}
                onRowClick={handleRowClickIncorporacao}
                dataOffCanvas={offCanvasDataIncorporacoes}
                showPagination={false}
                botaoAbrirOffCanvas={false}
              />
            </CustomCol>
            <CustomCol style={{ marginTop: '15px', textAlign: 'right' }}>
              <CustomButton
                label="Nova incorporação"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={() => {
                  setUpdatingIncorporacao(false);
                  handleShowModalIncorporacao();
                }}
                disabled={fichaID == 'undefined' ? true : false}
              />
            </CustomCol>
          </BoxConteudo>

          {/* Modal Incorporação /*/}
          <Modal
            tituloModal="Incorporação na Política de Assistência Farmacêutica"
            open={showModalIncorporacao}
            onHide={handleShowModalIncorporacao}
          >
            <WorkspaceFicha>
              <Log {...logIncorporacaData} />
              <BoxConteudo boxTitulo="Dados da Incorporação">
                <CustomRow style={{ marginTop: '-15px' }}>
                  <CustomCol width="200px">
                    <SelectInput
                      name="statusIncorporacao"
                      options={statusIncorporacao}
                      label="Status da Incorporação"
                      value={formIncorporacao.statusIncorporacao}
                      onChange={handleChangeIncorporacao}
                      style={statusIncorporacaoStyle}
                      required
                    />
                  </CustomCol>
                  <CustomCol width="200px">
                    <Input
                      name="dataIncorporacao"
                      label="Data da Incorporação"
                      value={formIncorporacao.dataIncorporacao}
                      id="dataIncorporacao"
                      onChange={handleChangeIncorporacao}
                      type="date"
                      readonly={isStatusEmIncorporacaoReadOnly}
                      required={!isStatusEmIncorporacaoReadOnly}
                    />
                  </CustomCol>
                  <CustomCol width="300px">
                    <Input
                      name="portariaIncorporacao"
                      label="Nº da Portaria de Incorporação"
                      value={formIncorporacao.portariaIncorporacao}
                      id="portariaIncorporacao"
                      onChange={handleChangeIncorporacao}
                      readonly={isStatusEmIncorporacaoReadOnly}
                      required={!isStatusEmIncorporacaoReadOnly}
                    />
                  </CustomCol>

                  <CustomCol>
                    <Input
                      name="linkPortariaIncorporacao"
                      label="Link da Portaria de Incorporação"
                      value={formIncorporacao.linkPortariaIncorporacao}
                      id="linkPortariaIncorporacao"
                      onChange={handleChangeIncorporacao}
                      type="url"
                      readonly={isStatusEmIncorporacaoReadOnly}
                      onClick={() => {
                        if (formIncorporacao.linkPortariaIncorporacao) {
                          let url =
                            formIncorporacao.linkPortariaIncorporacao.trim(); // Remove espaços extras

                          // Adiciona "https://" se a URL não começar com "http://" ou "https://"
                          if (
                            !url.startsWith('http://') &&
                            !url.startsWith('https://')
                          ) {
                            url = `https://${url}`;
                          }

                          window.open(url, '_blank', 'noopener,noreferrer');
                        }
                      }}
                      style={{
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                    />
                  </CustomCol>
                </CustomRow>
                <CustomRow>
                  <CustomCol width="200px">
                    <SelectInput
                      name="documentoTecnicoOrientador"
                      options={documentoOrientador}
                      label="Documento Orientador"
                      value={formIncorporacao.documentoTecnicoOrientador}
                      onChange={handleChangeIncorporacao}
                      disabled={isStatusEmIncorporacaoReadOnly}
                    />
                  </CustomCol>
                  <CustomCol width="200px">
                    <Input
                      name="dataDocumento"
                      label="Data da Publicacação"
                      value={formIncorporacao.dataDocumento}
                      id="dataDocumento"
                      onChange={handleChangeIncorporacao}
                      type="date"
                      readonly={isStatusEmIncorporacaoReadOnly}
                    />
                  </CustomCol>
                  <CustomCol width="650px">
                    <Input
                      name="documentoTecnicoOrientadorTitulo"
                      label="Título do Documento Orientador"
                      value={formIncorporacao.documentoTecnicoOrientadorTitulo}
                      id="documentoTecnicoOrientadorTitulo"
                      onChange={handleChangeIncorporacao}
                      readonly={isStatusEmIncorporacaoReadOnly}
                    />
                  </CustomCol>

                  <CustomCol>
                    <Input
                      name="documentoTecnicoOrientadorLink"
                      label="Link do Documento Orientador"
                      value={formIncorporacao.documentoTecnicoOrientadorLink}
                      id="documentoTecnicoOrientadorLink"
                      onChange={handleChangeIncorporacao}
                      readonly={isStatusEmIncorporacaoReadOnly}
                      type="url"
                      onClick={() => {
                        if (formIncorporacao.documentoTecnicoOrientadorLink) {
                          let url =
                            formIncorporacao.documentoTecnicoOrientadorLink.trim(); // Remove espaços extras

                          // Adiciona "https://" se a URL não começar com "http://" ou "https://"
                          if (
                            !url.startsWith('http://') &&
                            !url.startsWith('https://')
                          ) {
                            url = `https://${url}`;
                          }

                          window.open(url, '_blank', 'noopener,noreferrer');
                        }
                      }}
                      style={{
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                    />
                  </CustomCol>
                </CustomRow>
                <CustomRow>
                  <CustomCol width="200px">
                    <SelectInput
                      name="statusPactuacao"
                      options={statusPactuacao}
                      label="Status da Pactuação"
                      value={formIncorporacao.statusPactuacao}
                      onChange={handleChangeIncorporacao}
                      disabled={isStatusEmIncorporacaoReadOnly}
                      required={!isStatusEmIncorporacaoReadOnly}
                      style={statusPactuacaoStyle}
                    />
                  </CustomCol>
                  <CustomCol width="200px" helpText="Data da reunião da CIT">
                    <Input
                      name="dataPactuacao"
                      label="Data da Pactuação"
                      value={formIncorporacao.dataPactuacao}
                      id="dataPactuacao"
                      onChange={handleChangeIncorporacao}
                      type="date"
                      readonly={!isPactuacaoReadOnly}
                      required={isPactuacaoReadOnly}
                    />
                  </CustomCol>
                  <CustomCol width="250px">
                    <Input
                      name="ataPactuacao"
                      label="Nº da Ata"
                      value={formIncorporacao.ataPactuacao}
                      id="ataPactuacao"
                      onChange={handleChangeIncorporacao}
                      readonly={!isPactuacaoReadOnly}
                      required={isPactuacaoReadOnly}
                    />
                  </CustomCol>

                  <CustomCol width="200px">
                    <SelectInput
                      name="componentePactuado"
                      options={componenteAf}
                      label="Componente AF"
                      value={formIncorporacao.componentePactuado}
                      onChange={handleChangeIncorporacao}
                      disabled={!isPactuacaoReadOnly}
                      required={isPactuacaoReadOnly}
                    />
                  </CustomCol>
                  <CustomCol width="200px">
                    <SelectInput
                      name="componenteGrupoFinanciamento"
                      options={grupoFinanciamento}
                      label="Grupo Financiamento"
                      value={formIncorporacao.componenteGrupoFinanciamento}
                      onChange={handleChangeIncorporacao}
                      disabled={!isComponentePactuadoReadOnly}
                      required={isComponentePactuadoReadOnly}
                    />
                  </CustomCol>

                  <CustomCol>
                    <Input
                      name="ataPactuacaoLink"
                      label="Link da Ata"
                      value={formIncorporacao.ataPactuacaoLink}
                      id="ataPactuacaoLink"
                      onChange={handleChangeIncorporacao}
                      readonly={!isPactuacaoReadOnly}
                      type="url"
                      onClick={() => {
                        if (formIncorporacao.ataPactuacaoLink) {
                          let url = formIncorporacao.ataPactuacaoLink.trim(); // Remove espaços extras

                          // Adiciona "https://" se a URL não começar com "http://" ou "https://"
                          if (
                            !url.startsWith('http://') &&
                            !url.startsWith('https://')
                          ) {
                            url = `https://${url}`;
                          }

                          window.open(url, '_blank', 'noopener,noreferrer');
                        }
                      }}
                      style={{
                        color: 'blue',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                    />
                  </CustomCol>
                </CustomRow>
                <CustomRow>
                  <CustomCol width="200px">
                    <Input
                      name="dataDesincorporacao"
                      label="Data da Desincorporação"
                      value={formIncorporacao.dataDesincorporacao}
                      id="dataDesincorporacao"
                      onChange={handleChangeIncorporacao}
                      type="date"
                      readonly={isStatusIncorporacaoReadonly}
                      required={!isStatusIncorporacaoReadonly}
                    />
                  </CustomCol>

                  <CustomCol width="300px">
                    <Input
                      name="portariaDesincorporacao"
                      label="Nº da Portaria de Desincorporação"
                      value={formIncorporacao.portariaDesincorporacao}
                      id="portariaDesincorporacao"
                      onChange={handleChangeIncorporacao}
                      readonly={isStatusIncorporacaoReadonly}
                      required={!isStatusIncorporacaoReadonly}
                    />
                  </CustomCol>
                  <CustomCol>
                    <Input
                      name="linkPortariaDesincorporacao"
                      label="Link da Portaria de Desincorporação"
                      value={formIncorporacao.linkPortariaDesincorporacao}
                      id="linkPortariaDesincorporacao"
                      onChange={handleChangeIncorporacao}
                      type="url"
                      readonly={isStatusIncorporacaoReadonly}
                    />
                  </CustomCol>
                </CustomRow>

                <CustomRow>
                  <CustomCol width="100%">
                    <Input
                      id="observacoes"
                      name="observacoes"
                      value={formIncorporacao.observacoes}
                      label="Observações"
                      type="textarea"
                      onChange={handleChangeIncorporacao}
                      linhas={3}
                    />
                  </CustomCol>
                </CustomRow>
              </BoxConteudo>
              <BarraInferiorBotoes>
                {updatingIncorporacao ? (
                  <WorkspaceBotoes
                    delete
                    onClickDelete={handleDeleteIncorporacao}
                    save
                    onClickSave={handleUpdateIncorporacao}
                  />
                ) : (
                  <WorkspaceBotoes
                    inserir
                    onClickInserir={handleCreateIncorporacao}
                  />
                )}
              </BarraInferiorBotoes>
            </WorkspaceFicha>
          </Modal>

          {/* Outros Sistemas */}
          <BoxConteudo boxTitulo="Outros Sistemas">
            <CustomCol width="100%">
              <Tabela
                headers={headersOutrosSistemas}
                dataTable={tableDataOutroSistema}
                displayValues={valoresExibidosOutrosSistemas}
                onRowClick={handleRowClickOutroSistema}
                dataOffCanvas={offCanvasDataOutroSistema}
                showPagination={false}
                botaoAbrirOffCanvas={false}
              />
            </CustomCol>
            <CustomCol style={{ marginTop: '15px', textAlign: 'right' }}>
              <CustomButton
                label="Novo registro"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={() => {
                  setUpdatingOutroSistema(false);
                  handleShowModalOutroSistema();
                }}
                disabled={fichaID == 'undefined' ? true : false}
              />
            </CustomCol>
          </BoxConteudo>

          {/* Modal Outros Sistemas /*/}
          <Modal
            tituloModal="Outro Sistema"
            open={showModalOutroSistema}
            onHide={handleShowModalOutroSistema}
          >
            <WorkspaceFicha>
              <Log {...logIncorporacaData} />
              <BoxConteudo boxTitulo="Dados da Produto no Outro Sistema">
                <CustomRow style={{ marginTop: '-15px' }}>
                  <CustomCol width="200px">
                    <SelectInput
                      name="outroSistema"
                      options={outroSistema}
                      label="Sistema"
                      value={formOutroSistema.outroSistema}
                      onChange={handleChangeOutroSistema}
                      style={statusIncorporacaoStyle}
                      required
                    />
                  </CustomCol>
                  <CustomCol width="200px">
                    <Input
                      name="codigoProduto"
                      label="Código do Produto"
                      value={formOutroSistema.codigoProduto}
                      id="codigoProduto"
                      onChange={handleChangeOutroSistema}
                      required
                    />
                  </CustomCol>
                  <CustomCol>
                    <Input
                      name="nomeProduto"
                      label="Nome do Produto"
                      value={formOutroSistema.nomeProduto}
                      id="nomeProduto"
                      onChange={handleChangeOutroSistema}
                      required
                    />
                  </CustomCol>
                </CustomRow>

                <CustomRow>
                  <CustomCol width="100%">
                    <Input
                      id="observacoes"
                      name="observacoes"
                      value={formIncorporacao.observacoes}
                      label="Observações"
                      type="textarea"
                      onChange={handleChangeIncorporacao}
                      linhas={3}
                    />
                  </CustomCol>
                </CustomRow>
              </BoxConteudo>
              <BarraInferiorBotoes>
                {updatingOutroSistema ? (
                  <WorkspaceBotoes
                    delete
                    onClickDelete={handleDeleteOutroSistema}
                    save
                    onClickSave={handleUpdateOutroSistema}
                  />
                ) : (
                  <WorkspaceBotoes
                    inserir
                    onClickInserir={handleCreateOutroSistema}
                  />
                )}
              </BarraInferiorBotoes>
            </WorkspaceFicha>
          </Modal>

          {/* Kits de Produtos Farmacêuticos */}
          <BoxConteudo
            boxTitulo="Kits de Produtos Farmacêuticos"
            helpText="Mostra os Kits de Produtos Farmacêuticos que o produto faz parte. Para adicionar o produto ao um novo Kit vá para 'Produtos DAF > Kits de Produtos'."
          >
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="100%">
                <Tabela
                  headers={headersKitsProdutos}
                  dataTable={tableDataKit}
                  displayValues={valoresExibidosOffCanvasKitProdutos}
                  dataOffCanvas={offCanvasKit}
                  showPagination={false}
                  rowClickable={false}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Observações Gerais" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="100%">
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formProduto.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            deleteDisabled={!canDelete}
            onClickDelete={handleProdutoDelete}
            //     relatorio
            //    relatorioDisabled={!canRelatorio}
            //   onClickRelatorio={handleShowRelatorio}
            save
            saveDisabled={!canSave}
            onClickSave={handleProdutoUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleProdutoCreate} />
        )}
      </BarraInferiorBotoes>
      {showRelatorio && (
        <Modal
          icone="report"
          tituloModal="Relatório de Produto Farmacêutico"
          open={showRelatorio}
          onHide={handleShowRelatorio}
          modalSize="grande"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <RelatorioPDF
              titulo="Relatório de Produto Farmacêutico"
              template="tpProdutoDaf001"
              nomeCompleto={user.name || 'Usuário não identificado'}
              sections={[
                //Log
                {
                  title: 'Log',
                  data: [
                    {
                      usuarioRegistro: logData.usuarioRegistro
                        ? logData.usuarioRegistro.nomeCompleto
                        : 'N/A',
                      usuarioAtualizacao: logData.usuarioAtualizacao
                        ? logData.usuarioAtualizacao.nomeCompleto
                        : 'N/A',
                      dataRegistro: formatDtTm(logData.dataRegistro) || 'N/A',
                      dataAtualizacao:
                        formatDtTm(logData.dataUltimaAtualizacao) || 'N/A',
                      edicoes: logData.nEdicoes || 0,
                    },
                  ],
                  fields: [
                    {
                      label: 'Responsável pelo Registro',
                      key: 'usuarioRegistro',
                    },
                    {
                      label: 'Responsável Últ. Atualização',
                      key: 'usuarioAtualizacao',
                    },
                    { label: 'Data de Registro', key: 'dataRegistro' },
                    {
                      label: 'Última Atualização',
                      key: 'dataAtualizacao',
                    },
                    { label: 'Edições', key: 'edicoes' },
                  ],
                },
                // Dados do Produto Farmacêutico
                {
                  title: 'Dados do Produto Farmacêutico',
                  data: [
                    {
                      statusDistribuicao: formProduto.statusDistribuicao,
                      produtoFarmaceutico: formProduto.produtoFarmaceutico,
                      concentracao: formProduto.concentracao || 'Não informado',
                      formaFarmaceutica:
                        formaFarmaceutica.find(
                          (item) =>
                            parseInt(item.value, 10) ===
                            formProduto.formaFarmaceutica,
                        )?.label || 'Não informado',
                      aware:
                        classificacaoAware.find(
                          (item) =>
                            parseInt(item.value, 10) === formProduto.aware,
                        )?.label || 'Não informado',
                      umidade:
                        umidade.find(
                          (item) =>
                            parseInt(item.value, 10) === formProduto.umidade,
                        )?.label || 'Não informado',
                      acondicionamento:
                        acondicionamento.find(
                          (item) =>
                            parseInt(item.value, 10) ===
                            formProduto.acondicionamento,
                        )?.label || 'Não informado',
                    },
                  ],
                  fields: [
                    { label: 'Status Distribuição', key: 'statusDistribuicao' },
                    {
                      label: 'Produto Farmacêutico',
                      key: 'produtoFarmaceutico',
                    },
                    { label: 'Tipo de Produto', key: 'concentracao' },
                    { label: 'Denominação Genérica', key: 'concentracao' },
                    { label: 'Concentração química', key: 'concentracao' },
                    { label: 'Forma Farmacêutica', key: 'formaFarmaceutica' },
                    { label: 'AwARE', key: 'aware' },
                    { label: 'Umidade', key: 'umidade' },
                    { label: 'Acondicionamento', key: 'acondicionamento' },
                  ],
                },
                // Incorporação na Assistência Farmacêutica
                {
                  title: 'Incorporação na Assistência Farmacêutica',
                  data: [
                    {
                      statusIncorporacao:
                        statusIncorporacao.find(
                          (item) =>
                            parseInt(item.value, 10) ===
                            formIncorporacao.statusIncorporacao,
                        )?.label || 'Não informado',
                      dataIncorporacao:
                        formIncorporacao.dataIncorporacao || 'N/A',
                      portariaIncorporacao:
                        formIncorporacao.portariaIncorporacao || 'N/A',
                      linkPortariaIncorporacao:
                        formIncorporacao.linkPortariaIncorporacao || 'N/A',
                      documentoTecnicoOrientador:
                        documentoOrientador.find(
                          (item) =>
                            parseInt(item.value, 10) ===
                            formIncorporacao.documentoTecnicoOrientador,
                        )?.label || 'Não informado',
                      observacoes: formIncorporacao.observacoes || 'Nenhuma',
                    },
                  ],
                  fields: [
                    {
                      label: 'Status da Incorporação',
                      key: 'statusIncorporacao',
                    },
                    { label: 'Data de Incorporação', key: 'dataIncorporacao' },
                    {
                      label: 'Portaria de Incorporação',
                      key: 'portariaIncorporacao',
                    },
                    {
                      label: 'Link da Portaria',
                      key: 'linkPortariaIncorporacao',
                    },
                    {
                      label: 'Documento Orientador',
                      key: 'documentoTecnicoOrientador',
                    },
                    { label: 'Observações', key: 'observacoes' },
                  ],
                },
                // Outros Sistemas
                {
                  title: 'Outros Sistemas',
                  data: [
                    {
                      sigtap:
                        formProduto.sigtapPossui === 'S'
                          ? `${formProduto.sigtapCodigo} - ${formProduto.sigtapNome}`
                          : 'Não possui',
                      sismat:
                        formProduto.sismatPossui === 'S'
                          ? `${formProduto.sismatCodigo} - ${formProduto.sismatNome}`
                          : 'Não possui',
                      catmat:
                        formProduto.catmatPossui === 'S'
                          ? `${formProduto.catmatCodigo} - ${formProduto.catmatNome}`
                          : 'Não possui',
                      obm:
                        formProduto.obmPossui === 'S'
                          ? `${formProduto.obmCodigo} - ${formProduto.obmNome}`
                          : 'Não possui',
                    },
                  ],
                  fields: [
                    { label: 'SIGTAP', key: 'sigtap' },
                    { label: 'SISMAT', key: 'sismat' },
                    { label: 'CATMAT', key: 'catmat' },
                    { label: 'OBM', key: 'obm' },
                  ],
                },
                // Observações Gerais
                {
                  title: 'Observações Gerais',
                  data: [
                    {
                      observacoes:
                        formProduto.observacoes ||
                        'Nenhuma observação registrada.',
                    },
                  ],
                  fields: [{ label: 'Observações Gerais', key: 'observacoes' }],
                },
              ]}
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export default ProdutosDadosGerais;
